import axios from 'axios'
import qs from 'qs'

const api = axios.create({
  baseURL: process.env.API_URL,
  paramsSerializer: function (params) {
    return qs.stringify(params, { arrayFormat: 'repeat' })
  }
})
export default api



// WEBPACK FOOTER //
// ./src/services/api.js